// Stubs for API endpoints that don't exist yet.
// Each matches the useMutation signature so the swap is a one-line import change.

import { useMutation } from "@tanstack/vue-query";
import type { UseMutationOptions, UseMutationReturnType } from "@tanstack/vue-query";

// TODO: Replace with real Orval hook when DELETE /api/recipe/:id or DELETE /api/abstract-action/:id exists
export const useDeleteAbstractAction = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<void, TError, { id: string }, TContext>;
  },
): UseMutationReturnType<void, TError, { id: string }, TContext> => {
  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      console.warn(`[STUB] DELETE /api/abstract-action/${id}`);
      await new Promise((r) => setTimeout(r, 300));
    },
    ...options?.mutation,
  });
};

// TODO: Replace with real Orval hook when POST /api/recipe/:id/remove-action exists
export const useRemoveActionFromRecipe = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<void, TError, { id: string; data: { actions: string[] } }, TContext>;
  },
): UseMutationReturnType<void, TError, { id: string; data: { actions: string[] } }, TContext> => {
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: { actions: string[] } }) => {
      console.warn(`[STUB] POST /api/recipe/${id}/remove-action`, data);
      await new Promise((r) => setTimeout(r, 300));
    },
    ...options?.mutation,
  });
};

// TODO: Replace with real Orval hook when POST /api/abstract-action/:id/remove-article exists
export const useRemoveArticleFromAbstractAction = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<void, TError, { id: string; data: { articles: string[] } }, TContext>;
  },
): UseMutationReturnType<void, TError, { id: string; data: { articles: string[] } }, TContext> => {
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: { articles: string[] } }) => {
      console.warn(`[STUB] POST /api/abstract-action/${id}/remove-article`, data);
      await new Promise((r) => setTimeout(r, 300));
    },
    ...options?.mutation,
  });
};
